/* global Search */
import {
    renderListingCard,
    renderSearchForm,
    renderLoadMore,
    renderNoResults,
} from "./searchTemplates";

const FUNNELBACK_ENDPOINT =
    "https://wood-search.funnelback.squiz.cloud/s/search.json";
const PUSH_COLLECTION = "wood~sp-push-data";

/**
 * Initialize a Funnelback listing instance on a target DOM container
 * @param {Object} config - Configuration object
 * @returns {Object|null} Funnelback Search instance or null if container not found
 */
export const initFunnelbackListing = (config) => {
    const container = document.querySelector(config.selector);
    if (!container) return null;

    let hasActiveFilters = false;
    let instance = null;

    const fbParams = {
        profile: "_default",
        ...(config.pageType ? { "f.pageType|pageType": config.pageType } : {}),
        ...(config.additionalParams || {}),
    };

    instance = new Search.default({
        url: FUNNELBACK_ENDPOINT,
        collections: [PUSH_COLLECTION],
        additionalFBparams: fbParams,
        shouldFacetsFromUrlOverwriteActiveFacets: true,

        onFiltersUpdate: () => {
            const activeFacets = instance?.search?.activeFacets;
            hasActiveFilters = false;
            if (activeFacets) {
                for (const key in activeFacets) {
                    const entry = activeFacets[key];
                    if (Array.isArray(entry) && entry.length > 0) {
                        hasActiveFilters = true;
                        break;
                    } else if (entry && entry.value && entry.value.length > 0) {
                        hasActiveFilters = true;
                        break;
                    }
                }
            }
            return hasActiveFilters;
        },

        beforeSearch: () => {},

        results: {
            numRanks: config.numRanks || 18,
            startRank: 1,
        },

        sort: {
            type: "date",
        },

        pagination: {
            loadMore: config.loadMore !== false,
            arrows: false,
            arrowsOnEdgePages: false,
            dots: false,
            edgePages: false,
            pages: 0,
        },

        activeFacetsOnStart: {
            "f.Geography|categorisationGeography": [],
            "f.Sectors|categorisationSectors": [],
            "f.Solutions|categorisationSolutions": [],
            "f.pageType|pageType": [],
            "f.keyMarketEnergy|keyMarketEnergy": [],
            "f.keyMarketEnvironment|keyMarketEnvironment": [],
            "f.geographies|geographies": [],
        },

        templates: {
            articleTemplate: (fields) => renderListingCard(fields, config),
            informationTemplate: () => "",
            formTemplate: (search, query, inputId) =>
                renderSearchForm(query, inputId, config.placeholder),
            paginationNumberTemplate: () => "",
            activePaginationNumberTemplate: () => "",
            paginationTemplate: (pages) =>
                `<div class="search__pagination">${pages}</div>`,
            loadMoreTemplate: renderLoadMore,
            noResults: () => renderNoResults(hasActiveFilters),
        },
    });

    // Backwards-compatibility: attach to window global if specified (e.g. window.searchCS)
    if (config.windowKey) {
        window[config.windowKey] = instance;
    }

    instance.init();
    return instance;
};
